import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBagIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 6h-3V5a1.9999 1.9999 0 0 0-2-2h-4a2 2 0 0 0-2 2v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3Zm-9-1h4v1h-4V5Zm10 13a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1v-5.61L8.68 14c.1062.0144.2138.0144.32 0h6a1.189 1.189 0 0 0 .32-.05L20 12.39V18Zm0-7.72L14.84 12H9.16L4 10.28V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1.28Z"/>
  </SvgIcon>
}

export default LineBagIcon
